import { create } from 'zustand';

import {
	DEFAULT_MOBILE_PLATFORM,
	MobilePlatform
} from 'src/apps/dashboard/constants/MobileDashboard.constants';

interface IMobileDashboardFiltersStore {
	platform: MobilePlatform;
	appId: string | null;
	businessUnitId: string | null;
	setPlatform: (platform: MobilePlatform) => void;
	setAppId: (appId: string | null) => void;
	setBusinessUnitId: (businessUnitId: string | null) => void;
	resetMobileFilters: () => void;
}

export const useMobileDashboardFiltersStore = create<IMobileDashboardFiltersStore>((set) => ({
	platform: DEFAULT_MOBILE_PLATFORM,
	appId: null,
	businessUnitId: null,
	setPlatform: (platform) => set({ platform }),
	setAppId: (appId) => set({ appId }),
	setBusinessUnitId: (businessUnitId) => set({ businessUnitId }),
	resetMobileFilters: () =>
		set({
			platform: DEFAULT_MOBILE_PLATFORM,
			appId: null,
			businessUnitId: null
		})
}));
